__turbopack_context__.v({
  "label": "iUQI-W_label",
  "leftSection": "iUQI-W_leftSection",
  "root": "iUQI-W_root",
});
